module.exports = __webpack_public_path__ + "static/media/046-woman-12.5e41f2c1.svg";